var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 18.8335H16.6693",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.576 3.55228L12.1939 2.93436C13.2177 1.91055 14.8776 1.91055 15.9014 2.93436C16.9252 3.95816 16.9252 5.61807 15.9014 6.64187L15.2835 7.25979M11.576 3.55228C11.576 3.55228 11.6532 4.86535 12.8118 6.02395C13.9704 7.18255 15.2835 7.25979 15.2835 7.25979M11.576 3.55228L5.89515 9.2331C5.51038 9.61788 5.31799 9.81027 5.15254 10.0224C4.95736 10.2726 4.79003 10.5434 4.6535 10.8299C4.53776 11.0727 4.45172 11.3308 4.27964 11.8471L3.55048 14.0346M15.2835 7.25979L9.60267 12.9406C9.2179 13.3254 9.02551 13.5178 8.81338 13.6832C8.56315 13.8784 8.2924 14.0457 8.00592 14.1823C7.76307 14.298 7.50495 14.3841 6.98872 14.5561L4.80122 15.2853M4.80122 15.2853L4.2665 15.4635C4.01246 15.5482 3.73238 15.4821 3.54302 15.2927C3.35367 15.1034 3.28756 14.8233 3.37224 14.5693L3.55048 14.0346M4.80122 15.2853L3.55048 14.0346",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.8654e4cb0730dd9f9d920c2de06cbeaa.svg";
export { ForwardRef as ReactComponent };